import React, { useEffect, useState } from "react";
import EventCard from "./cards/eventCard/EventCard";
import AddCard from "./cards/addCard/AddCard";
import NewEventForm from "./newEventForm/NewEventForm";
import "./EventsList.css";
import EventManager from "../../utils/managers/EventManager";
import { useTranslation } from "react-i18next";
import { collection, onSnapshot } from "firebase/firestore";
import { db } from "../../db/firebase.config";

export default function EventsList({ isLoggedIn }) {
  const [showNewEventForm, setShowNewEventForm] = useState({
    isShown: false,
    eventData: null,
  });
  const [isLoading, setIsLoading] = useState(false);
  const [loadingCardsAmount, setLoadingCardsAmount] = useState(0);
  const [events, setEvents] = React.useState([]);

  const { t } = useTranslation();

  useEffect(() => {
    setIsLoading(true);

    EventManager.getEvents().then((events) => {
      if (events) setEvents(events);
      setIsLoading(false);
    });
    const unsubscribe = onSnapshot(collection(db, "eventsTitles"), () => {
      EventManager.getEvents().then((events) => {
        if (events) setEvents(events);
      });
    });
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    const windowWidth = window.innerWidth / 2;
    setLoadingCardsAmount(Math.floor(windowWidth / 400) + 1);
  }, []);

  return (
    <div className="events__wrapper">
      <section className="events-section" id="events">
        <div className="events__heading">
          <div>
            <span className="events__eyebrow">ACTIVE GENERATION</span>
            <h2 className="events__title">{t("eventsList.title")}</h2>
          </div>
          <p className="events__intro">{t("eventsList.intro")}</p>
        </div>

        <div className="events__calendar">
          <div className="events__calendar-bar">
            <span>{t("eventsList.calendar")}</span>
            <strong>{new Date().getFullYear()}</strong>
          </div>

          <div className="events">
            {isLoading ? (
              Array(loadingCardsAmount)
                .fill()
                .map((_, index) => <EventCard key={index} isLoading={true} />)
            ) : (
              <>
                {events.length ? (
                  [...events]
                    .sort((a, b) => new Date(a.dates.start) - new Date(b.dates.start))
                    .map((ev, index) => (
                    <EventCard
                      key={`${ev.title}${index}`}
                      isLoggedIn={isLoggedIn}
                      id={ev.id}
                      eventData={ev}
                      setShowNewEventForm={setShowNewEventForm}
                    />
                  ))
                ) : (
                  <p className="events__message">{t("eventsList.noEvents")}</p>
                )}
              </>
            )}

            {isLoggedIn && events.length < EventManager.MAX_EVENTS && (
              <AddCard setShowNewEventForm={setShowNewEventForm} />
            )}
          </div>
        </div>

        {showNewEventForm.isShown && (
          <NewEventForm
            eventData={showNewEventForm.eventData || null}
            setShowNewEventForm={setShowNewEventForm}
          />
        )}
      </section>
    </div>
  );
}
